export default __webpack_public_path__ + "static/media/close.c6335fb1.svg";